import { PlaidLinkContextProvider } from '@/features/user/settings/sections/connected-financial-institutions-card/plaid/LinkContext'
import { PlaidErrorDialog } from '@/features/user/settings/sections/connected-financial-institutions-card/plaid/ErrorDialog'
import { DuplicateInstitutionDialog } from '@/features/user/settings/sections/connected-financial-institutions-card/DuplicateInstitutionDialog'
import { PlaidLauncher } from '@/features/user/settings/sections/self-service/financial-institutions/PlaidLauncher'

export const ChatPlaidLauncher = () => (
  <PlaidLinkContextProvider>
    <PlaidLauncher surface="adviser" />
    <DuplicateInstitutionDialog />
    <PlaidErrorDialog />
  </PlaidLinkContextProvider>
)
